/**
 * avatars/aliens/species/species-batch2.js
 * Dữ liệu chủng tộc văn minh (Nhóm 2).
 */

import {
  SPECIES_DRAKONIS,
  SPECIES_SYLVA,
  SPECIES_INSECT,
  SPECIES_VENOM,
  SPECIES_DUNE,
  SPECIES_SERAPH,
  SPECIES_LITHOS,
  SPECIES_GEM,
  SPECIES_MERCURY,
  SPECIES_MIDAS
} from '../species-ids.js';

export const SPECIES_BATCH_2 = {
  [SPECIES_DRAKONIS]: {
    speciesId: 'species_drakonis',
    shortName: 'Long Nhân Hậu Duệ',
    cardSubtitle: 'Drakonis • Sừng & vảy rồng',
    name: 'Long Nhân Hậu Duệ (Drakonis)',
    planet: 'Drakonis',
    lore: 'Hậu duệ rồng vũ trụ đầy phẩm giá và hào hiệp. Họ là những người kiến tạo hiệp ước hòa bình giữa các chòm sao và bảo vệ các sinh quyển nguyên sinh khỏi sự tàn phá.',
    reactions: [
      {
        action: 'wave',
        text: 'Drakonis rộng mở đón chào! Long tộc chúng tôi luôn khắc ghi tình bằng hữu với người lương thiện.'
      },
      {
        action: 'explain',
        text: 'Hào khí long tộc được dùng để giữ gìn cân bằng sinh thái tinh cầu và bảo vệ các giống loài non trẻ.'
      },
      {
        action: 'present',
        text: 'Đôi cánh và vảy rồng tượng trưng cho sự dũng cảm, trí tuệ và khát vọng tự do bay lượn giữa các vì sao.'
      }
    ],
    dna: {
      skinColor: '#b91c1c',
      eyeType: 'fire',
      horns: 'dragon_horns',
      wings: 'dragon_wings',
      tail: 'dragon_tail',
      hairColor: '#262626',
      eyeColor: '#ef4444',
      pantsColor: '#450a0a',
      shoesColor: '#171717'
    },
    clothing: {
      maleOutfit: 'drakonis_male',
      femaleOutfit: 'drakonis_female',
      shirtPalette: ['#450a0a', '#7f1d1d', '#991b1b', '#b91c1c']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_SYLVA]: {
    speciesId: 'species_sylva',
    shortName: 'Người Rừng Thảo Mộc',
    cardSubtitle: 'Sylva Prime • Xơ thực vật',
    name: 'Người Rừng Thảo Mộc (Sylva Prime)',
    planet: 'Sylva Prime',
    lore: 'Nền văn minh sinh thái gắn bó mật thiết với đại ngàn Sylva Prime. Họ là những người làm vườn vũ trụ tận tụy, nghiên cứu việc tái sinh các vùng đất cằn cỗi và bảo vệ sự đa dạng sinh học.',
    reactions: [
      {
        action: 'wave',
        text: 'Chào người bạn phương xa! Hương hoa rừng Sylva Prime hôm nay thật tươi mát đón chào bạn.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi dệt y phục từ xơ thực vật tái sinh, không làm tổn hại bất kỳ nhánh cây sống nào.'
      },
      {
        action: 'present',
        text: 'Hạt giống sinh thái này có thể nảy mầm và thanh lọc bầu không khí trên mọi hành tinh bạn ghé thăm.'
      }
    ],
    dna: {
      skinColor: '#65a30d',
      eyeType: 'normal',
      horns: 'emerald_horns',
      wings: 'none',
      tail: 'none',
      hairColor: '#14532d',
      eyeColor: '#4ade80',
      pantsColor: '#166534',
      shoesColor: '#052e16'
    },
    clothing: {
      maleOutfit: 'sylva_male',
      femaleOutfit: 'sylva_female',
      shirtPalette: ['#3f6212', '#4d7c0f', '#166534', '#365314']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_INSECT]: {
    speciesId: 'species_insect',
    shortName: 'Người Giáp Trùng Kitin',
    cardSubtitle: 'Entomo-Hive • Cánh bọ gập',
    name: 'Người Giáp Trùng Kitin (Entomo-Hive)',
    planet: 'Entomo-Hive',
    lore: 'Cộng đồng văn minh tổ hợp trật tự tại Entomo-Hive. Họ sở hữu đôi cánh kitin thanh mảnh và tinh thần hợp tác tuyệt vời, nổi tiếng với kỹ nghệ kiến trúc tổ vòm sinh thái kỳ vĩ.',
    reactions: [
      {
        action: 'wave',
        text: 'Xin kính chào! Entomo-Hive luôn trân trọng mọi sứ giả hòa bình ghé thăm tổ vòm sinh thái.'
      },
      {
        action: 'explain',
        text: 'Lớp vỏ kitin và cánh bọ nhẹ giúp chúng tôi bay lượn linh hoạt giữa các tầng kiến trúc cao vút.'
      },
      {
        action: 'present',
        text: 'Mật hoa tinh chế của chúng tôi vừa là nguồn dinh dưỡng tinh khiết, vừa là dược liệu chữa lành tự nhiên.'
      }
    ],
    dna: {
      skinColor: '#d97706',
      eyeType: 'normal',
      horns: 'tesla_antennae',
      wings: 'insect_wings',
      tail: 'none',
      hairColor: '#451a03',
      eyeColor: '#f59e0b',
      pantsColor: '#78350f',
      shoesColor: '#292524'
    },
    clothing: {
      maleOutfit: 'insect_male',
      femaleOutfit: 'insect_female',
      shirtPalette: ['#78350f', '#92400e', '#b45309', '#451a03']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_VENOM]: {
    speciesId: 'species_venom',
    shortName: 'Cư Dân Sinh Thái Axit',
    cardSubtitle: 'Venom-Ooze • Bộ lọc sinh thái',
    name: 'Cư Dân Sinh Thái Axit (Venom-Ooze)',
    planet: 'Venom-Ooze',
    lore: 'Các nhà khoa học và kỹ sư sinh hóa sống tại vùng đầm lầy hóa chất Venom-Ooze. Họ làm chủ công nghệ chuyển hóa các hợp chất axit đậm đặc thành vật liệu sinh học siêu bền và năng lượng sạch.',
    reactions: [
      {
        action: 'wave',
        text: 'Chào mừng bạn! Hệ thống lọc khí sinh quyển đã sẵn sàng để bạn có một chuyến tham quan an toàn tuyệt đối.'
      },
      {
        action: 'explain',
        text: 'Chúng tôi trung hòa mọi chất độc và tái chế chúng thành các polymer sinh học siêu bền.'
      },
      {
        action: 'present',
        text: 'Bộ lọc khí thanh lịch này giúp chúng tôi làm việc thoải mái trong mọi môi trường hóa học khắc nghiệt.'
      }
    ],
    dna: {
      skinColor: '#10b981',
      eyeType: 'normal',
      hat: 'gas_mask_helm',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#064e3b',
      eyeColor: '#10b981',
      pantsColor: '#134e4a',
      shoesColor: '#042f2e'
    },
    clothing: {
      maleOutfit: 'venom_male',
      femaleOutfit: 'venom_female',
      shirtPalette: ['#047857', '#065f46', '#0f766e', '#134e4a']
    },
    demographics: {
      maleHair: 'neat_parted',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_DUNE]: {
    speciesId: 'species_dune',
    shortName: 'Người Du Mục Sa Mạc',
    cardSubtitle: 'Dune-Solaris • Áo choàng cát',
    name: 'Người Du Mục Sa Mạc (Dune-Solaris)',
    planet: 'Dune-Solaris',
    lore: 'Những người lữ hành kiên cường trên biển cát vàng Dune-Solaris. Họ nắm giữ bản đồ hải trình thiên văn cổ đại và văn hóa hiếu khách truyền thống, luôn chia sẻ nước mát cho mọi khách lạ qua đường.',
    reactions: [
      {
        action: 'wave',
        text: 'Bình an cho bạn! Hãy cùng chúng tôi ngồi bên bóng râm đụn cát và thưởng thức tách trà mát lạnh.'
      },
      {
        action: 'explain',
        text: 'Y phục du mục giúp chúng tôi phản xạ nhiệt mặt trời ban ngày và giữ ấm hoàn hảo trong đêm lạnh sa mạc.'
      },
      {
        action: 'present',
        text: 'Bản đồ thiên văn cát này ghi lại mọi tuyến ốc đảo an toàn trên toàn bộ bán cầu nắng.'
      }
    ],
    dna: {
      skinColor: '#b45309',
      eyeType: 'normal',
      hat: 'mu_cao_boi',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#78350f',
      eyeColor: '#fbbf24',
      pantsColor: '#451a03',
      shoesColor: '#292524'
    },
    clothing: {
      maleOutfit: 'dune_male',
      femaleOutfit: 'dune_female',
      shirtPalette: ['#b45309', '#92400e', '#78350f', '#a16207']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_SERAPH]: {
    speciesId: 'species_seraph',
    shortName: 'Người Ánh Sáng Thiên Thần',
    cardSubtitle: 'Aethelgard • Cánh thiên sứ',
    name: 'Người Ánh Sáng Thiên Thần (Aethelgard)',
    planet: 'Aethelgard',
    lore: 'Cư dân của tinh cầu ánh sáng Aethelgard. Họ sở hữu đôi cánh thiên sứ lông vũ tỏa sáng và phát triển nền văn minh quang học tối tân, luôn đem năng lượng chữa lành và sự hòa hợp đến các hệ sao.',
    reactions: [
      {
        action: 'wave',
        text: 'Ánh sáng thanh khiết từ Aethelgard xin gửi lời chào ấm áp đến bạn!'
      },
      {
        action: 'explain',
        text: 'Chúng tôi sử dụng quang tử tự nhiên để sưởi ấm tâm hồn và nuôi dưỡng các vùng sinh quyển ánh sáng.'
      },
      {
        action: 'present',
        text: 'Đôi cánh thiên sứ giúp chúng tôi hấp thu photon năng lượng và bay lượn trên các tầng mây quang điện.'
      }
    ],
    dna: {
      skinColor: '#fef08a',
      eyeType: 'star',
      wings: 'angel_wings',
      horns: 'none',
      tail: 'none',
      hairColor: '#fef3c7',
      eyeColor: '#38bdf8',
      pantsColor: '#ca8a04',
      shoesColor: '#854d0e'
    },
    clothing: {
      maleOutfit: 'seraph_male',
      femaleOutfit: 'seraph_female',
      shirtPalette: ['#fef9c3', '#fef08a', '#fde047', '#eab308']
    },
    demographics: {
      maleHair: 'neat_parted',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_LITHOS]: {
    speciesId: 'species_lithos',
    shortName: 'Người Đá Thạch Cổ Tự',
    cardSubtitle: 'Archaea-Rune • Đá phiến rune',
    name: 'Người Đá Thạch Cổ Tự (Archaea-Rune)',
    planet: 'Archaea-Rune',
    lore: 'Bộ tộc các học giả và thợ khắc đá cự thạch tại Archaea-Rune. Cơ thể họ bền bỉ như đá hoa cương nghìn năm và lưu giữ hệ thống cổ tự rune ghi chép lịch sử địa chất vũ trụ.',
    reactions: [
      {
        action: 'wave',
        text: 'Chào bạn! Khối đá ngàn năm Archaea-Rune rung động chào đón bước chân của sứ giả văn minh.'
      },
      {
        action: 'explain',
        text: 'Những ký tự rune phát sáng trên da lưu giữ kho tàng kiến thức địa chất qua hàng triệu niên kỷ.'
      },
      {
        action: 'present',
        text: 'Trang phục đá phiến ghép đai da giúp chúng tôi thoải mái khai phá các hang động tinh thể sâu thẳm.'
      }
    ],
    dna: {
      skinColor: '#64748b',
      eyeType: 'star',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#1e293b',
      eyeColor: '#94a3b8',
      pantsColor: '#0f172a',
      shoesColor: '#020617'
    },
    clothing: {
      maleOutfit: 'lithos_male',
      femaleOutfit: 'lithos_female',
      shirtPalette: ['#334155', '#475569', '#1e293b', '#64748b']
    },
    demographics: {
      maleHair: 'bald',
      femaleHair: 'short_neat',
      childHair: 'short_neat',
      elderHair: 'bald'
    }
  },

  [SPECIES_GEM]: {
    speciesId: 'species_gem',
    shortName: 'Người Tinh Thể Thạch Anh',
    cardSubtitle: 'Krystalia • Sừng pha lê',
    name: 'Người Tinh Thể Thạch Anh (Krystalia)',
    planet: 'Krystalia',
    lore: 'Nền văn minh nghệ thuật tinh xảo tại vương quốc tinh thể Krystalia. Họ sở hữu sừng pha lê tán sắc cầu vồng và nắm giữ công nghệ quang học lăng kính khúc xạ ánh sáng đa chiều.',
    reactions: [
      {
        action: 'wave',
        text: 'Chào mừng bạn đến với Krystalia! Hãy cùng chiêm ngưỡng bản giao hưởng sắc màu của các tinh thể.'
      },
      {
        action: 'explain',
        text: 'Mỗi chỏm sừng pha lê là một lăng kính khúc xạ ánh sáng, giúp chúng tôi cảm nhận trọn vẹn quang phổ vũ trụ.'
      },
      {
        action: 'present',
        text: 'Y phục của chúng tôi được dệt từ sợi khoáng tinh thể mềm mại, lấp lánh phản quang dưới mọi góc nhìn.'
      }
    ],
    dna: {
      skinColor: '#fed7aa',
      eyeType: 'star',
      horns: 'crystal_horns',
      wings: 'none',
      tail: 'none',
      hairColor: '#9a3412',
      eyeColor: '#fb923c',
      pantsColor: '#7c2d12',
      shoesColor: '#431407'
    },
    clothing: {
      maleOutfit: 'gem_male',
      femaleOutfit: 'gem_female',
      shirtPalette: ['#ea580c', '#f97316', '#fb923c', '#c2410c']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_MERCURY]: {
    speciesId: 'species_mercury',
    shortName: 'Cư Dân Thủy Ngân Lỏng',
    cardSubtitle: 'Hydrargis • Gương kim loại',
    name: 'Cư Dân Thủy Ngân Kim Loại Lỏng (Hydrargis)',
    planet: 'Hydrargis',
    lore: 'Cộng đồng cư dân sống tại hồ kim loại lỏng Hydrargis. Cơ thể họ có bề mặt ánh bạc phản chiếu như gương và khả năng biến đổi linh hoạt, dẫn đầu trong ngành luyện kim lượng tử tiên tiến.',
    reactions: [
      {
        action: 'wave',
        text: 'Gương sáng Hydrargis phản chiếu người bạn lương thiện! Rất vui được tương tác cùng bạn.'
      },
      {
        action: 'explain',
        text: 'Lớp bề mặt kim loại lỏng cho phép chúng tôi tự tái cấu trúc để thích nghi hoàn hảo với mọi nhiệt độ khắc nghiệt.'
      },
      {
        action: 'present',
        text: 'Trang phục mạ crom phản quang vừa bảo vệ tối ưu, vừa tôn vinh vẻ đẹp kim khí thanh lịch.'
      }
    ],
    dna: {
      skinColor: '#cbd5e1',
      eyeType: 'cyber_visor',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#334155',
      eyeColor: '#e2e8f0',
      pantsColor: '#1e293b',
      shoesColor: '#0f172a'
    },
    clothing: {
      maleOutfit: 'mercury_male',
      femaleOutfit: 'mercury_female',
      shirtPalette: ['#475569', '#334155', '#64748b', '#94a3b8']
    },
    demographics: {
      maleHair: 'spiky',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  },

  [SPECIES_MIDAS]: {
    speciesId: 'species_midas',
    shortName: 'Người Hoàng Kim Giác Vàng',
    cardSubtitle: 'Aurum-Vega • Dát vàng lá',
    name: 'Người Hoàng Kim Giác Vàng (Aurum-Vega)',
    planet: 'Aurum-Vega',
    lore: 'Cư dân của tinh cầu hoàng kim Aurum-Vega. Họ sở hữu làn da ánh vàng lá và kỹ nghệ chế tác kim hoàn vũ trụ vô song, xem vàng như chất dẫn năng lượng tinh khiết phục vụ hòa bình.',
    reactions: [
      {
        action: 'wave',
        text: 'Chào mừng bạn đến với vùng đất ánh vàng rực rỡ Aurum-Vega!'
      },
      {
        action: 'explain',
        text: 'Chúng tôi dùng kim loại quý để chế tạo các vi mạch năng lượng vĩnh cửu phục vụ đời sống cộng đồng.'
      },
      {
        action: 'present',
        text: 'Huy hiệu mặt trời vàng trên ngực là biểu trưng cho sự thịnh vượng và lòng bác ái của tộc người hoàng kim.'
      }
    ],
    dna: {
      skinColor: '#f59e0b',
      eyeType: 'star',
      horns: 'none',
      wings: 'none',
      tail: 'none',
      hairColor: '#b45309',
      eyeColor: '#fbbf24',
      pantsColor: '#92400e',
      shoesColor: '#78350f'
    },
    clothing: {
      maleOutfit: 'midas_male',
      femaleOutfit: 'midas_female',
      shirtPalette: ['#d97706', '#b45309', '#92400e', '#f59e0b']
    },
    demographics: {
      maleHair: 'neat_parted',
      femaleHair: 'long_hair',
      childHair: 'short_neat',
      elderHair: 'neat_parted'
    }
  }
};
